import { ThunkType } from "../../../../../core/store/reducers";
import { getMemberContractsExcel } from "../api/getMemberContractsExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../memberContractsDataSlice";

export const downloadMemberContractsExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getMemberContractsExcel(user));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "MemberContracts.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
